import warrantyImg from "@/assets/warranty.png";

export const Warranty = () => {
  return (
    <section className="pb-20 relative">
      <div className="container px-4">
        <div className="text-center mb-16 animate-slide-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Garantia incondicional de<br/>
            <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">
              7 dias
            </span>
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Você tem 7 dias completos para acessar o método, assistir à vídeo‑aula, aplicar as técnicas e perceber melhorias no seu dia a dia. Se, dentro desse prazo, entender que o conteúdo não atendeu às suas expectativas, solicite o reembolso — sem perguntas, sem burocracia, sem risco.
            <br />
            <span className="bg-gradient-accent bg-clip-text text-transparent drop-shadow-[0_0_18px_rgba(100,192,242,0.6)]">A responsabilidade é nossa. A decisão de continuar é sua.</span>
          </p>
        </div>

        <img 
          src={warrantyImg} 
          alt="Garantia de 7 dias" 
          className="w-full max-w-md mx-auto transition-all duration-700 animate-pulseZoom" 
        />
      </div>
    </section>
  );
};
